// The Founder Box card, first in the Diamond shop while it is on sale and not yet bought (shared/founder.ts).
// Buying goes through the shop's two-step confirm (data-act="shop").
import { FOUNDER, founderOffered } from '../shared/founder.ts';
import { OUTFIT } from '../shared/outfits.ts';
import { S } from './state.ts';
import { spriteUrl } from './assets.ts';
import { esc } from './fmt.ts';
import { confirmLabel, priceLabel, isArmed } from './confirm.ts';
import { mySprite } from './trainerart.ts';

export function founderCard(): string {
  const t = S.trainer;
  if (!t || !founderOffered(S.founderOpen, t)) return '';
  const key = `shop:${FOUNDER.offer}`;
  return `<section class="panel sf-pass fb-card" aria-label="Founder Box"><div class="sf-pass-art fb-art"><img class="pz-show-pic" src="${spriteUrl(`${mySprite(FOUNDER.outfit)}-down-0`)}" alt=""></div>
    <div class="sf-pass-body"><span class="pz-eyebrow">Launch only · once per account</span><h3>Founder Box</h3>
      <ul class="sp-list"><li>${esc(OUTFIT[FOUNDER.outfit].name)}</li><li><span class="cbadge" aria-hidden="true">${FOUNDER.badge.glyph}</span>${esc(FOUNDER.badge.name)} badge</li></ul>
      <button class="btn gold${isArmed(key) ? ' armed' : ''}" data-act="shop" data-id="${FOUNDER.offer}"${t.diamonds < FOUNDER.price ? ' disabled title="Not enough diamonds"' : ''}>${priceLabel(key, `Buy · ${FOUNDER.price} ◆`, FOUNDER.price)}</button></div></section>`;
}
